// react
import { useEffect, useState } from "react";
// redux
import { useAppDispatch } from "../../../redux/hooks";
import { loadItems, useNopimsBasket } from "../nopimsBasketSlice";
// common
import TaskLayout from "../../../common/shell/TaskLayout";
import { ValidationVisibilityEnum } from "../../../common/validation/ValidationModel";
import * as toastHelper from "../../../common/toastHelper";
// me
import { IRootViewModel, RootViewModel, ViewStateEnum } from "./models/models";
import * as actions from "./actions";
import NopimsPageLayout from "../../shell/NopimsPageLayout";
import BasketView from "./BasketView";
import SubmitView from "./SubmitView";

import validator from "./models/validator";

export default function Controller(): React.JSX.Element {
    const { userToken, items } = useNopimsBasket();
    const dispatch = useAppDispatch();

    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());

    const [validationVisibility, setValidationVisibility] = useState(ValidationVisibilityEnum.Messages);
    const validation = validator(vm, validationVisibility);

    // on mount
    useEffect(() => {
        actions.initialiseSubmit(setVm);
    }, []);

    // on basket mount
    useEffect(() => {
        if (vm.viewState === ViewStateEnum.Basket) dispatch(loadItems());
    }, [vm.viewState]); // eslint-disable-line react-hooks/exhaustive-deps

    function handleShowSubmitBasket(): void {
        setVm(vm.stateChanged(ViewStateEnum.Submit));
    }
    function handleCancelSubmitBasket(): void {
        setVm(vm.stateChanged(ViewStateEnum.Basket));
    }
    function handleSubmitComplete(): void {
        if (!validation.isValid()) {
            setValidationVisibility(ValidationVisibilityEnum.MessagesAndAdorners);
            toastHelper.showValidationErrorNotification();
            return;
        }

        setValidationVisibility(ValidationVisibilityEnum.None);
        actions.submitBasket(userToken!, vm, setVm);
    }
    function onExport(): void {
        actions.exportBasket(userToken!, setVm);
    }

    return (
        <NopimsPageLayout title={["Basket"]}>
            <TaskLayout statusMessages={vm.statusMessages} isDirty={vm.isDirty} isBusy={vm.isBusy} error={vm.error}>
                {vm.viewState === ViewStateEnum.Submit ? (
                    <SubmitView vm={vm} setVm={setVm} validation={validation} onSubmit={handleSubmitComplete} onCancel={handleCancelSubmitBasket} />
                ) : (
                    <BasketView items={items} onShowSubmitBasket={handleShowSubmitBasket} onExport={onExport} />
                )}
            </TaskLayout>
        </NopimsPageLayout>
    );
}
